import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["maximumStudents", "lessonStructure", "thirdFourthStudentStructure"]

  connect() {
    this.updateThirdFourthStudentStructureVisibility()
  }

  updateThirdFourthStudentStructureVisibility() {
    if (!this.hasMaximumStudentsTarget || !this.hasLessonStructureTarget || !this.hasThirdFourthStudentStructureTarget) return

    const maximumStudents = parseInt(this.maximumStudentsTarget.value, 10)
    const shouldShow = maximumStudents >= 3 && this.lessonStructureTarget.value === "turns"

    this.thirdFourthStudentStructureTarget.classList.toggle("u-hidden", !shouldShow)
    this.thirdFourthStudentStructureTarget
      .querySelectorAll("select")
      .forEach((field) => {
        if (!shouldShow) field.value = "observe_only"
      })
  }
}
